// extracted by mini-css-extract-plugin
export default {"roleContainer":"Selector_roleContainer__KuQdD","leftSide":"Selector_leftSide__z7XfC","rolePlate":"Selector_rolePlate__mnVON","roleDescr":"Selector_roleDescr__WBWbK"};